module.exports = __webpack_public_path__ + "static/media/level-background.9d0f9142.svg";